import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _extends from "@babel/runtime/helpers/extends";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  border-right: 1px solid ", ";\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  width: ", ";\n  padding-top: ", "px;\n  transition: padding-top 200ms ease-in-out;\n  overflow: auto;\n  background: ", ";\n\n  @media screen and (max-width: ", ") {\n      width: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  transition: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// this is a special sider that 'knows' about the header so it sized properly.
// we did not replace sider, since sider can be used in other situations.
import * as React from 'react';
import styled from 'styled-components';
import Sider from './Sider';
import { AppLayoutContext } from './AppLayoutContext';

var LeftSider = function LeftSider(props) {
  return /*#__PURE__*/React.createElement(AppLayoutContext.Consumer, null, function (_ref) {
    var currentHeaderHeight = _ref.currentHeaderHeight;
    return /*#__PURE__*/React.createElement(StyledLeftSider, _extends({
      trigger: null,
      breakpoint: "md"
    }, props), /*#__PURE__*/React.createElement(FixedContainer, {
      paddingTop: currentHeaderHeight,
      breakpoint: props.breakpoint || 'md',
      width: props.width,
      collapsedWidth: props.collapsedWidth
    }, props.children));
  });
};

var StyledLeftSider = styled(Sider)(_templateObject(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.color.white;
});
var FixedContainer = styled.div(_templateObject2(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.border["default"];
}, function (_ref4) {
  var width = _ref4.width;
  return width;
}, function (_ref5) {
  var paddingTop = _ref5.paddingTop;
  return paddingTop;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.color.white;
}, function (_ref7) {
  var theme = _ref7.theme,
      breakpoint = _ref7.breakpoint;
  return theme.breakpoints[breakpoint];
}, function (_ref8) {
  var collapsedWidth = _ref8.collapsedWidth;
  return collapsedWidth;
});
export default LeftSider;